import { useEffect, useMemo, useState, useCallback } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@chakra-ui/react";
import SearchTabs from "./SearchTabs";
import * as getresearchCentreAll from "../../../services/Search";
// import { All } from "./All"; // All tab commented out for now
import { Library } from "./Library";
import { Archive } from "./Archive";
// import { Highlights } from "./Highlights"; // Highlights tab commented out for now
import { Video } from "./Video";

export const LibraryAndArchive = ({
  masterlist,
  SearchTerm,
  setAllCount,
  allCount
}) => {
  const [visible, setVisible] = useState(true); // true = grid, false = list
  const [listGridIcon, setListGridIcon] = useState(true);
  const { tabValue } = useParams();
  const [attr, setAttr] = useState(0);
  const [libraryCount, setLibraryCount] = useState(0);
  const [archiveCount, setArchiveCount] = useState(0);
  // const [highlightCount, setHighlightCount] = useState(0); // Highlights tab commented out for now
  const [VideoCount, setVideoCount] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sortData, setSortData] = useState({
    sort: [],
    filterOptions: {},
    handleCheckboxChange: null,
    setApply: null,
    hasData: false,
    showFilterBox: false,
    handleFilterClick: null,
    filterAvailable: false
  });

  const pathToIndex = useMemo(() => {
    const indexMap = {
      // 'all': 0, // All tab commented out for now
      'library': 0,
      'archive': 1
    };
    let currentIndex = 2;
    if (VideoCount > 0) {
      indexMap['video'] = currentIndex;
      currentIndex++;
    }
    // Highlights tab commented out for now
    // if (highlightCount > 0) {
    //   indexMap['highlights'] = currentIndex;
    // }
    return indexMap;
  }, [VideoCount]);
  
  useEffect(() => {
    setAttr(pathToIndex[tabValue] ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, pathToIndex]);

  // Wrapper function to only update sortData for the active tab
  // We'll check if the tab is active when the callback is invoked
  const handleSortDataChange = useCallback((tabId) => {
    return (sortData) => {
      // Check if this tab is currently active by comparing with tabValue from URL
      const currentTabId = tabValue || 'library';
      if (currentTabId === tabId) {
        setSortData(sortData);
      }
    };
  }, [tabValue]);

  // Removed - listGridIcon is now managed by tabPanelData.list property

  // Fetch data only when SearchTerm changes
  useEffect(() => {
    if (!SearchTerm) return;
    
    let isMounted = true;
    
    async function fetchData() {
      try {
        const [libraryResult, archiveResult, videoResult] = await Promise.all([
          // getresearchCentreAll.searchResearchAllTab(SearchTerm, {}, 1), // All tab commented out for now
          getresearchCentreAll.searchResearchLibraryTab(SearchTerm, {}, 1),
          getresearchCentreAll.searchResearchArchiveTab(SearchTerm, {}, 1),
          // getresearchCentreAll.searchResearchHighlightTab(SearchTerm, {}, 1), // Highlights tab commented out for now
          getresearchCentreAll.searchResearchVideoTab(SearchTerm, {}, 1),
        ]);
        
        if (!isMounted) return;
        
        // if (allResult) {
        //   setAllCount(allResult?.total || 0);
        // }
        if (libraryResult) {
          setLibraryCount(libraryResult?.total || 0);
        }
        if (archiveResult) {
          setArchiveCount(archiveResult?.total || 0);
        }
        // if (highlightResult) {
        //   setHighlightCount(highlightResult?.total || 0);
        // }
        if (videoResult) {
          setVideoCount(videoResult?.total || 0);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    
    fetchData();
    
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm]);

  const formatData = useMemo(() => {
    const data = [
      // All tab commented out for now
      // {
      //   id: "all",
      //   title: getTranslation('ALL'),
      //   count: allCount,
      //   component: (
      //     <Box key={`all-${SearchTerm}`}>
      //       <All
      //         masterlist={null}
      //         masterlistType="search"
      //         setAllCount={setAllCount}
      //         SearchTerm={SearchTerm}
      //         filterbuttonStyle={null}
      //         visible={visible}
      //         onSortDataChange={setSortData}
      //       />
      //     </Box>
      //   ),
      //   list: true
      // },
      {
        id: "library",
        title: 'Library',
        count: libraryCount,
        component: (
          <Box key={`library-${SearchTerm}-${tabValue || 'library'}`}>
            <Library
              visible={visible}
              SearchTerm={SearchTerm}
              setLibraryCount={setLibraryCount}
              masterlistType="search"
              filterbuttonStyle={null}
              onSortDataChange={handleSortDataChange("library")}
            />
          </Box>
        ),
        list: true
      },
      {
        id: "archive",
        title: 'Archive',
        count: archiveCount,
        component: (
          <Box key={`archive-${SearchTerm}-${tabValue || 'archive'}`}>
            <Archive
              SearchTerm={SearchTerm}
              setArchiveCount={setArchiveCount}
              masterlistType="search"
              filterbuttonStyle={null}
              onSortDataChange={handleSortDataChange("archive")}
            />
          </Box>
        ),
        list: false
      },
    ];

    if (VideoCount > 0) {
      data.push({
        id: "video",
        title: 'Videos',
        count: VideoCount,
        component: (
          <Box key={`video-${SearchTerm}-${tabValue || 'video'}`}>
            <Video
              SearchTerm={SearchTerm}
              setVideoCount={setVideoCount}
              masterlistType="search"
              filterbuttonStyle={null}
              onSortDataChange={handleSortDataChange("video")}
            />
          </Box>
        ),
        list: false
      });
    }

    // Highlights tab commented out for now
    // if (highlightCount > 0) {
    //   data.push({
    //     id: "highlights",
    //     title: getTranslation('HIGHLIGHTS'),
    //     count: highlightCount,
    //     className: "count-label-green",
    //     component: (
    //       <Box key={`highlights-${SearchTerm}`}>
    //         <Highlights
    //           masterlist={null}
    //           masterlistType="search"
    //           setHighlightCount={setHighlightCount}
    //           SearchTerm={SearchTerm}
    //           filterbuttonStyle={null}
    //           visible={visible}
    //           onSortDataChange={setSortData}
    //         />
    //       </Box>
    //     ),
    //     list: true
    //   });
    // }

    return data;
  }, [libraryCount, archiveCount, VideoCount, visible, SearchTerm, setLibraryCount, setArchiveCount, setVideoCount, handleSortDataChange, tabValue]);

  const tabPanelData = formatData;

  const handleTabChange = (index) => {
    setAttr(index);
    const selectedTab = tabPanelData[index];
    const tabName = selectedTab?.id || 'library'; // Changed default from 'all' to 'library'
    const query = searchParams.get('query');
    if (query) {
      navigate(`/search/research-centre/${tabName}?query=${encodeURIComponent(query)}`, { replace: true });
    } else {
      navigate(`/search/research-centre/${tabName}`, { replace: true });
    }
  };

  // Update listGridIcon based on current tab
  useEffect(() => {
    const currentTab = tabPanelData[attr];
    if (currentTab) {
      setListGridIcon(currentTab.list);
    }
  }, [attr, tabPanelData]);

  return (
    <Stack position={"relative"} width={"100%"} py={4}>
      {tabPanelData && tabPanelData?.length > 0 ? (
        <SearchTabs
          list={tabPanelData}
          index={attr}
          visible={visible}
          setVisible={setVisible}
          listGridIcon={listGridIcon}
          onTabChange={handleTabChange}
          sort={sortData.sort}
          filterOptions={sortData.filterOptions}
          handleCheckboxChange={sortData.handleCheckboxChange}
          setApply={sortData.setApply}
          masterlistType="search"
          hasData={sortData.hasData}
          searchTerm={SearchTerm}
          showFilterBox={sortData.showFilterBox}
          onFilterToggle={sortData.handleFilterClick}
          filterAvailable={sortData.filterAvailable}
        />
      ) : null}
    </Stack>
  );
};
